module.exports = __webpack_public_path__ + "img/point.73283a35.jpg";